/**
 * Video embedding types and interfaces
 */

export interface VideoAttributes {
  id: string;
  sourceUrl: string;
  width: number;
  height: number;
  x: number;
  y: number;
  videoType: 'mp4' | 'youtube';
}

export interface VideoControlsAttributes {
  x: number;
  y: number;
  width?: number;
  height?: number;
}

export interface VideoTransformAttributes {
  transform: string;
  clipPath: string;
}

export interface VideoConfiguration {
  attributes: VideoAttributes;
  controls: VideoControlsAttributes;
  transforms: VideoTransformAttributes;
}

export const VIDEO_CONSTANTS = {
  DEFAULT_BUTTON_SIZE: 100,
  REFERENCE_CANVAS_SIZE: 1600,
  DEFAULT_VIDEO_TYPE: 'mp4',
} as const;

export const VIDEO_BUTTON_ICONS = {
  PLAY: `
    <svg style="width: 100%; height: 100%;" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.25 0.138672C11.3718 0.138672 0.125 11.4206 0.125 25.3331C0.125 39.2456 11.3718 50.5276 25.25 50.5276C39.1282 50.5276 50.375 39.2456 50.375 25.3331C50.375 11.4206 39.1282 0.138672 25.25 0.138672Z"
        fill="rgba(0, 0, 0, 0.45)"
      />
      <path
        d="M23.2523 16.5768L33.4543 23.3975C34.9952 25.0923 34.9952 25.5739 33.4543 27.2688L23.2522 34.0895C20.2889 35.704 19.625 33.0014 19.625 32.1165V18.5497C19.625 17.6649 20.2889 15.9623 23.2523 16.5768Z"
        fill="#FFFFFF"
      />
    </svg>
  `,
  PAUSE: `
    <svg style="width: 100%; height: 100%;" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.25 0.138672C11.3718 0.138672 0.125 11.4206 0.125 25.3331C0.125 39.2456 11.3718 50.5276 25.25 50.5276C39.1282 50.5276 50.375 39.2456 50.375 25.3331C50.375 11.4206 39.1282 0.138672 25.25 0.138672Z"
        fill="rgba(0, 0, 0, 0.45)"
      />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 18H23V33H20V18ZM28 18H31V33H28V18Z" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2" stroke-linejoin="round"/>
    </svg>
  `,
} as const;
